// extracted by mini-css-extract-plugin
export var attachment = "_q3-a";
export var emailContainer = "_q3-4";
export var emailContentPaddedContainer = "_q3-b";
export var emailHeader = "_q3-6";
export var emailIframe = "_q3-3";
export var emailInfoIcon = "_q3-9";
export var emailShortenedSummary = "_q3-e";
export var infoDropdown = "_q3-0";
export var infoRowBoundedContent = "_q3-d";
export var internal = "_q3-5";
export var merchant = "_q3-8";
export var messageInputContainer = "_q3-h";
export var normal = "_q3-7";
export var replyCard = "_q3-f";
export var subtleButton = "_q3-1";
export var subtleButtonIconContainer = "_q3-2";
export var toggleViewRepliesButton = "_q3-c";
export var wrappingText = "_q3-g";